// src/pages/SignOut.js
import { useEffect } from 'react';
import { logout } from '../utils/auth';

const SignOut = () => {
  useEffect(() => {
    // Use the centralized logout function
    logout();
  }, []);

  return null; // User will be redirected immediately
};

export default SignOut;
